import axios from "axios";

class BinanceApi {
    async getCryptoPrices() {
    const coinsRate = []
    const tickers = [
        'BTCUSDT',
        'ETHUSDT',
        'BNBUSDT',
        'SOLUSDT',
        'XRPUSDT',
        'ADAUSDT',
        'DOGEUSDT',
        'LTCUSDT',
        'MATICUSDT', // Polygon теперь может торговаться как POL, но MATIC все еще актуален
        'TRXUSDT',
        'EURUSDT'   // Курс Евро к USDT
        // XMR (Monero) исключен, так как был удален (делистинг) с Binance.
    ];
    //console.log('🔄 Запрашиваем актуальные курсы с Binance...');

    // Базовый URL для API Binance
    const baseUrl = 'https://api.binance.com/api/v3/ticker/price';

    try {
        // Создаем массив запросов (промисов) для каждого тикера
        const requests = tickers.map(ticker => axios.get(`${baseUrl}?symbol=${ticker}`));

        // Один недоступный тикер не должен обнулять курсы всех остальных валют.
        const responses = await Promise.allSettled(requests);

        //console.log('✅ Цены успешно получены:\n');

        // Обрабатываем и выводим каждый ответ
        responses.forEach((result, index) => {
            if (result.status !== 'fulfilled') {
                console.warn(`Binance API - ${tickers[index]} is unavailable`);
                coinsRate.push('0');
                return;
            }

            const { symbol, price } = result.value.data;
            // Форматируем цену для лучшей читаемости
            const formattedPrice = parseFloat(price).toFixed(4);
            coinsRate.push(formattedPrice)
            //console.log(`Binance API - ${index}: ${symbol} = $${formattedPrice}`);
        });

    } catch (error) {
        // Обработка возможных ошибок (например, нет сети или неверный тикер)
        console.error('❌ Произошла ошибка при получении данных:', error.message);
    }
    return coinsRate
}
}

export const binanceApi = new BinanceApi();
